import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class CommonService {

	public userDetails: any;
	private loginRedirectUrl: any;
	public requestData: any;
	public viewData = new Subject();
	addressChange = new Subject();
	contactChange = new Subject();
	approverChange = new Subject();
	public searchChange = new Subject();
	public langChange = new Subject();
	public icbImageData: any
	public wrtImageData:any;
	public redirectUrl:string=null;

	public addressSource = new BehaviorSubject('0');		//BS for address change
	addressSourceObs = this.addressSource.asObservable();	//OBS for address change
  
	constructor() {}

	changeSearchData(data:any) {
		this.searchChange.next(data);
	}

	changeLanguage(data:any) {
		this.langChange.next(data);
	}

	setData(data: any) {
		this.requestData = data;
	}

	getData() {
		return this.requestData;
	}

	changeViewData(data){
		this.viewData.next(data);
	}


	changeAddressData() {
		this.addressChange.next();
  	}

	changeCurrentAddress(newAddressID){			//function for address ID change
		this.addressSource.next(newAddressID)
	}

	changeContactData() {
		this.contactChange.next();
  	}

	changeApproverData(action) {
		this.approverChange.next(action);
  	}

	setUserDetails(userDetails) {
		this.userDetails = userDetails;
	}

	setLoginRedirectUrl(url) {
		this.loginRedirectUrl = url;
	}
	getLoginRedirectUrl() {
		return this.loginRedirectUrl;
	}
	setIcbImageData(data: any) {
		this.icbImageData = data;
		console.log(this.icbImageData)
	}


	clearIcbImageData() {
		this.icbImageData = [];
		console.log(this.icbImageData)
	}

	

	getIcbImageData() {
		return this.icbImageData;
	}
	setWrtImageData(data: any) {
		this.wrtImageData = data;
	}
	getWrtImageData() {
		return this.wrtImageData;
	}
	contains(value, term, caseInsensitiveSearch) {
		if(!value) return false;
		if(!term) return false;
		if(caseInsensitiveSearch){
			value = value.toLowerCase();
			term = term.toLowerCase();
		}
		return (value.indexOf(term) != -1);
	}

	equals(value1, value2, caseInsensitiveMatch) {
		if(!value1) return false;
		if(!value2) return false;
		if(caseInsensitiveMatch){
			value1 = value1.toLowerCase();
			value2 = value2.toLowerCase();
		}
		return (value1==value2);
	}

	stopPropagationCheckBox(event) {
		if (event.stopPropagation) {
			event.stopPropagation();    // Standard
		}else {
			event.cancelBubble = true;  // Old IE
		}
	}

	getChoosenFile(event, componentModal, componentKey){
		let file = event.srcElement.files[0];
		let fileName  = file.name;
		var reader = new FileReader();
		reader.onload = function(){
			componentModal[componentKey] = {name:fileName,data:reader.result};
		}.bind(componentModal);
		reader.readAsDataURL(file);
	}
	filterDatatable(event,allFilterData){
        // get the value of the key pressed and make it lowercase
		
        let val = event.toLowerCase();
        // get the amount of columns in the table
        let colsAmt = allFilterData.length>0? Object.keys(allFilterData[0]).length: 0;
        // get the key names of each column in the dataset
        let keys = allFilterData.length > 0? Object.keys(allFilterData[0]): [];
        // assign filtered matches to the active datatable
		let data=[];
        if(val!="" && val.length>0){
			data = allFilterData.filter(function(item){
				// iterate through each row's column data
				for (let i=0; i<colsAmt; i++){
					// check for a match
					console.log(item)
					console.log(item[keys[i]])
					if (item && item[keys[i]] && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)){
					// found match, return true to add to result set
					return true;
					}
				}
				});

        }else{
            data = allFilterData;
        }
		return {'data':data,'table_offset':0};
        // whenever the filter changes, always go back to the first page
        // this.table.offset = 0;
      }

	  setRedirectUrl(url){
		  this.redirectUrl = url;
	  }
	  getRedirectUrl(){
		return this.redirectUrl;
	  }

	  // ===== FOC ROLE HELPERS =====

private FOC_ALLOWED_ROLES: string[] = [
	'FOC_APPROVER',
	'FOC_HR',
	'FOC_ADMINISTRATOR',
	'FOC_EMPLOYEE',
	'FOC_DISPLAY'
  ];
  
  // user has ANY FOC role
  hasFOCRole(roles: string[] = []): boolean {
	if (!roles || roles.length === 0) return false;
	return roles.some(r => this.FOC_ALLOWED_ROLES.indexOf(r) !== -1);
  }
  
  // user has ONLY FOC roles
  isOnlyFOCRole(roles: string[] = []): boolean {
	if (!roles || roles.length === 0) return false;
	return roles.every(r => this.FOC_ALLOWED_ROLES.indexOf(r) !== -1);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/services/common.service.ts